import { initGalleries } from './gallery';
import { initBuybox } from './buybox';
import { initBasket } from './basket';
import { initCheckout } from './checkout';

// The VAT switch: a class on <html> picks the prices shown (base.scss), saved for the next page (inc/vat.php, 4b item 9).
function vat_set(vat) {
    var html = document.documentElement;
    html.classList.remove('vat-ex', 'vat-inc');
    html.classList.add('vat-' + vat);
    try {
        localStorage.setItem('jfj-vat', vat);
    } catch (e) {
    }
    vat_pressed();
}

function vat_toggle() {
    vat_set(document.documentElement.classList.contains('vat-ex') ? 'inc' : 'ex');
}

// The header's inc/ex VAT buttons (views/partials/vat-switch.php) say which one is on, for screen readers.
function vat_pressed() {
    var ex = document.documentElement.classList.contains('vat-ex');
    document.querySelectorAll('.vatswitch button').forEach(function (b) {
        b.setAttribute('aria-pressed', String((b.dataset.vat === 'ex') === ex));
    });
}

// Header (Phase 5, views/partials/menubar.php): the mobile menu opens as a panel; Esc, the close button or a click
// outside it closes it and focus goes back to the menu button. Its sections open one at a time.
function initHeader() {
    vat_pressed();
    document.querySelectorAll('.vatswitch button').forEach(function (b) {
        b.addEventListener('click', function () {
            vat_set(b.dataset.vat);
        });
    });

    var nav = document.getElementById('mnav'), open = document.getElementById('mnav-open');
    if (!nav || !open) {
        return;
    }
    function close() {
        if (nav.hidden) {
            return;
        }
        nav.hidden = true;
        document.documentElement.classList.remove('mnav-open');
        open.setAttribute('aria-expanded', 'false');
        open.focus();
    }
    open.addEventListener('click', function () {
        nav.hidden = false;
        document.documentElement.classList.add('mnav-open');
        open.setAttribute('aria-expanded', 'true');
        nav.querySelector('.mnav-close').focus();
    });
    nav.querySelectorAll('[data-mnav-close]').forEach(function (el) {
        el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            close();
        }
    });
    // Widening the window past 1,200 px hides the menu button: close the panel with it.
    window.matchMedia('(min-width: 1200px)').addEventListener('change', function (m) {
        if (m.matches) {
            close();
        }
    });
    var parents = nav.querySelectorAll('.mnav-parent');
    parents.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var show = btn.getAttribute('aria-expanded') !== 'true';
            parents.forEach(function (other) {
                other.setAttribute('aria-expanded', 'false');
                document.getElementById(other.getAttribute('aria-controls')).hidden = true;
            });
            btn.setAttribute('aria-expanded', String(show));
            document.getElementById(btn.getAttribute('aria-controls')).hidden = !show;
        });
    });
}

// FAQs (views/page-wood-flooring-faqs.php): one answer open at a time (the shared name="faq" does it in browsers that
// know it; this does it in the rest). When the answer that closes is above, the page would move the clicked question
// up and off screen: it's scrolled back to where it was clicked. A link to /wood-flooring-faqs/#question opens that
// answer; opening one puts its address in the URL, so it can be shared.
function initFaqs() {
    var list = document.querySelector('[data-faqs]');
    if (!list) {
        return;
    }
    function fromHash() {
        var item = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (item && item.classList.contains('faq-item')) {
            item.open = true;
            item.scrollIntoView();
        }
    }
    list.querySelectorAll('.faq-item').forEach(function (item) {
        var summary = item.querySelector('summary'), clickedAt = null;
        summary.addEventListener('click', function () {
            clickedAt = summary.getBoundingClientRect().top;
        });
        item.addEventListener('toggle', function () {
            if (item.open) {
                list.querySelectorAll('.faq-item[open]').forEach(function (other) {
                    if (other !== item) {
                        other.open = false;
                    }
                });
                if (clickedAt !== null) {
                    window.scrollBy(0, summary.getBoundingClientRect().top - clickedAt);
                }
                history.replaceState(null, '', '#' + item.id);
            }
            clickedAt = null;
        });
    });
    window.addEventListener('hashchange', fromHash);
    fromHash();
}

// Range-page FAQs (Page1's markup in the category descriptions: .accordion > .accordion-item > .accordion-header +
// .accordion-content; styles in _page1.scss): a click on an item opens or closes its answer. Page1 had appended this
// to the built public/js/app.js, so it was lost when public/ went out of git (6071158c) and came back 2026-11-04.
function initRangeFaqs() {
    document.querySelectorAll('.accordion-item').forEach(function (item) {
        item.addEventListener('click', function () {
            item.classList.toggle('active');
            var content = item.querySelector('.accordion-content');
            if (content) {
                content.classList.toggle('show');
            }
        });
    });
}

jQuery(document).ready(function () {

    initHeader();
    initFaqs();
    initRangeFaqs();
    initBuybox();
    initBasket();
    initCheckout();







    jQuery('.product-extra-info .tab').hide();
    jQuery('.product-extra-info .first').show();
    jQuery('.titles .tabtitle').on('click', function () {
        var correcttab = jQuery(this).data('related');
        jQuery('.titles .tabtitle').removeClass('active');
        jQuery(this).addClass('active');
        correcttab = "." + correcttab;
        jQuery('.product-extra-info .tab').hide();
        jQuery(correcttab).show();

    });
    jQuery('.accordion h2').on('click', function () {
        jQuery('.accordion .tabmob').removeClass('active');
        jQuery(this).parent().addClass('active');
        var offset=jQuery(this).offset().top;
        console.log(offset);
        jQuery(window).scrollTop(offset -100);


    });

    jQuery('.toggle-vat').on('click', function () {

        vat_toggle();

    });

    /* Accordions (.title) */
    jQuery('.title').on('click', function () {
        if(jQuery(this).parent().hasClass('active')){
            jQuery(this).parent().removeClass('active');
        } else {
            jQuery(this).parent().addClass('active');
        }


    });


    initGalleries();

    (function ($) {
        $(document).on('facetwp-loaded', function () {
            if (FWP.loaded) {
                $('html, body').animate({
                    scrollTop: $('.search-grid').offset().top - 50
                }, 100);
            }
        });
    })(jQuery);
});

